import { Bar, mixins } from 'vue-chartjs'

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted: function() {
      this.chartOptions = {
        responsive: true,
        cutoutPercentage: 92,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom',
        },
        scales: {
          xAxes: [{
            barPercentage : 1.5
          }],
          yAxes: [{
            ticks: {
                    userCallback: function(value, index, values) {
                        //prevents crazy numbers if all the bars are zero
                        if(value < 1){
                            return null
                        }
                        // Convert the number to a string and splite the string every 3 charaters from the end
                        value = value.toString();
                        value = value.split(/(?=(?:...)*$)/);

                        // Convert the array to a string and format the output
                        value = value.join('.');
                        return value + ' €';
                    }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return tooltipItem.yLabel.toFixed(2) + ' €';
            },
            title: function(tooltipItem, data) {
              return null;
            }
          }
        }
      };

      this.renderChart(this.chartData, this.chartOptions)

    }
});



// WEBPACK FOOTER //
// ./src/tools/charts/reports/dateSummary.js